(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/common'), require('@shraddhar/web/floating-label'), require('@shraddhar/web/line-ripple'), require('@shraddhar/web/notched-outline'), require('@shraddhar/web/form-field'), require('@angular/forms'), require('@angular/cdk/coercion'), require('@angular/cdk/platform'), require('@shraddhar/web/ripple'), require('@shraddhar/web/base'), require('@material/textfield')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/web/textfield', ['exports', '@angular/core', '@angular/common', '@shraddhar/web/floating-label', '@shraddhar/web/line-ripple', '@shraddhar/web/notched-outline', '@shraddhar/web/form-field', '@angular/forms', '@angular/cdk/coercion', '@angular/cdk/platform', '@shraddhar/web/ripple', '@shraddhar/web/base', '@material/textfield'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.web = global.shraddhar.web || {}, global.shraddhar.web.textfield = {}), global.ng.core, global.ng.common, global.ng.web.floatingLabel, global.ng.web.lineRipple, global.ng.web.notchedOutline, global.ng.web.formField, global.ng.forms, global.ng.cdk.coercion, global.ng.cdk.platform, global.ng.web.ripple, global.ng.web.base, global.mdc.textfield));
}(this, (function (exports, core, common, floatingLabel, lineRipple, notchedOutline, formField, forms, coercion, platform, ripple, base, textfield) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var MdcTextFieldIcon = /** @class */ (function (_super) {
        __extends(MdcTextFieldIcon, _super);
        function MdcTextFieldIcon(elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this.elementRef = elementRef;
            _this._leading = false;
            _this._trailing = false;
            return _this;
        }
        Object.defineProperty(MdcTextFieldIcon.prototype, "leading", {
            get: function () {
                return this._leading;
            },
            set: function (value) {
                this._leading = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextFieldIcon.prototype, "trailing", {
            get: function () {
                return this._trailing;
            },
            set: function (value) {
                this._trailing = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextFieldIcon.prototype, "foundation", {
            get: function () {
                return this._foundation;
            },
            enumerable: true,
            configurable: true
        });
        MdcTextFieldIcon.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                getAttr: function (attr) { return _this._elementRef.nativeElement.getAttribute(attr); },
                setAttr: function (attr, value) { return _this._elementRef.nativeElement.setAttribute(attr, value); },
                removeAttr: function (attr) { return _this._elementRef.nativeElement.removeAttribute(attr); },
                setContent: function () { },
                registerInteractionHandler: function () { },
                deregisterInteractionHandler: function () { },
                notifyIconAction: function () { },
            };
            return new textfield.MDCTextFieldIconFoundation(adapter);
        };
        MdcTextFieldIcon.prototype.ngOnDestroy = function () {
            this.destroy();
        };
        MdcTextFieldIcon.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcTextFieldIcon]',
                        exportAs: 'mdcTextFieldIcon',
                        host: {
                            '[attr.tabindex]': 'trailing ? 0 : -1',
                            'class': 'mdc-text-field__icon',
                            '[class.mdc-text-field__icon--leading]': 'leading',
                            '[class.mdc-text-field__icon--trailing]': 'trailing'
                        }
                    },] }
        ];
        /** @nocollapse */
        MdcTextFieldIcon.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        MdcTextFieldIcon.propDecorators = {
            leading: [{ type: core.Input }],
            trailing: [{ type: core.Input }]
        };
        return MdcTextFieldIcon;
    }(base.MDCComponent));

    var MdcTextFieldHelperTextFoundation = /** @class */ (function (_super) {
        __extends(MdcTextFieldHelperTextFoundation, _super);
        function MdcTextFieldHelperTextFoundation(_hostElement, _document) {
            var _this = _super.call(this, _hostElement) || this;
            _this._hostElement = _hostElement;
            _this._document = _document;
            _this._initialized = false;
            return _this;
        }
        Object.defineProperty(MdcTextFieldHelperTextFoundation.prototype, "foundation", {
            get: function () {
                return this._foundation;
            },
            enumerable: true,
            configurable: true
        });
        MdcTextFieldHelperTextFoundation.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this._helperTextContentElement.classList.add(className); },
                removeClass: function (className) { return _this._helperTextContentElement.classList.remove(className); },
                hasClass: function (className) { return _this._helperTextContentElement.classList.contains(className); },
                setAttr: function (attr, value) { return _this._helperTextContentElement.setAttribute(attr, value); },
                removeAttr: function (attr) { return _this._helperTextContentElement.removeAttribute(attr); },
                setContent: function (content) { return _this._helperTextContentElement.textContent = content; },
            };
            return new textfield.MDCTextFieldHelperTextFoundation(adapter);
        };
        /** Sets the persistency of the helper text. */
        MdcTextFieldHelperTextFoundation.prototype.setPersistent = function (isPersistent) {
            this._foundation.setPersistent(isPersistent);
        };
        /** True to make the helper text act as an error validation message. */
        MdcTextFieldHelperTextFoundation.prototype.setValidation = function (isValidation) {
            this._foundation.setValidation(isValidation);
        };
        /** Sets the validity of the helper text based on inputIsValid. */
        MdcTextFieldHelperTextFoundation.prototype.setValidity = function (inputIsValid) {
            this._foundation.setValidity(inputIsValid);
        };
        /** Makes the helper text visible to the screen reader. */
        MdcTextFieldHelperTextFoundation.prototype.showToScreenReader = function () {
            this._foundation.showToScreenReader();
        };
        /** Sets the content of the helper text field. */
        MdcTextFieldHelperTextFoundation.prototype.setContent = function (content) {
            this._foundation.setContent(content);
        };
        /** Initializes the foundation. */
        MdcTextFieldHelperTextFoundation.prototype.init = function () {
            if (this._initialized) {
                return;
            }
            this._createHelperElement();
            this._foundation.init();
            this._initialized = true;
        };
        /** Destroys the foundation. */
        MdcTextFieldHelperTextFoundation.prototype.destroy = function () {
            var _a, _b;
            (_b = (_a = this._helperLineElement) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(this._helperLineElement);
            this._hostElement = this._helperLineElement = this._helperTextContentElement = null;
            this._foundation.destroy();
            this._initialized = false;
        };
        /** Creates and appends the helper element. */
        MdcTextFieldHelperTextFoundation.prototype._createHelperElement = function () {
            this._helperLineElement = this._document.createElement('div');
            this._helperTextContentElement = this._document.createElement('div');
            this._helperLineElement.className = 'mdc-text-field-helper-line';
            this._helperTextContentElement.className = 'mdc-text-field-helper-text';
            this._helperLineElement.appendChild(this._helperTextContentElement);
            this._appendHelperElement();
        };
        /**
         * Appends the helper element to the textfield or textarea.
         */
        MdcTextFieldHelperTextFoundation.prototype._appendHelperElement = function () {
            if (!this._helperLineElement) {
                throw Error('Helper element has not been created and cannot be appended');
            }
            this._hostElement.nativeElement.insertAdjacentElement('afterend', this._helperLineElement);
        };
        MdcTextFieldHelperTextFoundation.prototype.ngOnDestroy = function () {
            this.destroy();
        };
        return MdcTextFieldHelperTextFoundation;
    }(base.MDCComponent));

    var MdcTextFieldCharacterCounterFoundation = /** @class */ (function (_super) {
        __extends(MdcTextFieldCharacterCounterFoundation, _super);
        function MdcTextFieldCharacterCounterFoundation(_hostElement, _helperElement, _document) {
            var _this = _super.call(this, _hostElement) || this;
            _this._hostElement = _hostElement;
            _this._helperElement = _helperElement;
            _this._document = _document;
            _this._initialized = false;
            _this._root = _this._elementRef;
            return _this;
        }
        Object.defineProperty(MdcTextFieldCharacterCounterFoundation.prototype, "foundation", {
            get: function () {
                return this._foundation;
            },
            enumerable: true,
            configurable: true
        });
        /** Initializes the foundation. */
        MdcTextFieldCharacterCounterFoundation.prototype.init = function () {
            if (this._initialized) {
                return;
            }
            this._createCounterElement();
            this._foundation.init();
            this._initialized = true;
        };
        MdcTextFieldCharacterCounterFoundation.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                setContent: function (content) { return _this._characterCounterElement.textContent = content; },
            };
            return new textfield.MDCTextFieldCharacterCounterFoundation(adapter);
        };
        MdcTextFieldCharacterCounterFoundation.prototype.setCounterValue = function (currentLength, maxLength) {
            this.foundation.setCounterValue(currentLength, maxLength);
        };
        /** Creates and appends counter to the helper element. */
        MdcTextFieldCharacterCounterFoundation.prototype._createCounterElement = function () {
            this._characterCounterElement = this._document.createElement('div');
            this._characterCounterElement.className = 'mdc-text-field-character-counter';
            this._appendCounterElement();
        };
        /**
         * Appends the counter element to the textfield or textarea.
         */
        MdcTextFieldCharacterCounterFoundation.prototype._appendCounterElement = function () {
            if (!this._characterCounterElement) {
                throw Error('Helper element has not been created and cannot be appended');
            }
            this._helperElement.appendChild(this._characterCounterElement);
        };
        /** Destroys the foundation. */
        MdcTextFieldCharacterCounterFoundation.prototype.destroy = function () {
            var _a, _b;
            (_b = (_a = this._characterCounterElement) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(this._characterCounterElement);
            this._hostElement = this._characterCounterElement = null;
            this._foundation.destroy();
            this._initialized = false;
        };
        MdcTextFieldCharacterCounterFoundation.prototype.ngOnDestroy = function () {
            this.destroy();
        };
        return MdcTextFieldCharacterCounterFoundation;
    }(base.MDCComponent));

    /**
     * Injection token that can be used to configure the default options for all
     * mdc-text-field usage within an app.
     */
    var MDC_TEXT_FIELD_DEFAULT_OPTIONS = new core.InjectionToken('MDC_TEXT_FIELD_DEFAULT_OPTIONS');
    var MdcTextFieldBase = /** @class */ (function (_super) {
        __extends(MdcTextFieldBase, _super);
        function MdcTextFieldBase(_elementRef, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) {
            var _this = _super.call(this, _elementRef) || this;
            _this._elementRef = _elementRef;
            _this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
            _this._parentForm = _parentForm;
            _this._parentFormGroup = _parentFormGroup;
            _this.ngControl = ngControl;
            return _this;
        }
        return MdcTextFieldBase;
    }(base.MDCComponent));
    var _MdcTextFieldMixinBase = formField.mixinErrorState(MdcTextFieldBase);
    var nextUniqueId = 0;
    /**
     * Time in milliseconds for which to ignore mouse events, after
     * receiving a touch event. Used to avoid doing double work for
     * touch devices where the browser fires fake mouse events, in
     * addition to touch events.
     */
    var MOUSE_EVENT_IGNORE_TIME = 800;
    var MdcTextField = /** @class */ (function (_super) {
        __extends(MdcTextField, _super);
        function MdcTextField(_platform, _changeDetectorRef, elementRef, _defaultErrorStateMatcher, _document, _parentFormField, _ripple, ngControl, _parentForm, _parentFormGroup, _defaults) {
            var _this = _super.call(this, elementRef, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) || this;
            _this._platform = _platform;
            _this._changeDetectorRef = _changeDetectorRef;
            _this.elementRef = elementRef;
            _this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
            _this._document = _document;
            _this._parentFormField = _parentFormField;
            _this._ripple = _ripple;
            _this.ngControl = ngControl;
            _this._defaults = _defaults;
            _this._uid = "mdc-input-" + nextUniqueId++;
            _this._initialized = false;
            /** Time in milliseconds when the last touchstart event happened. */
            _this._lastTouchStartEvent = 0;
            _this.controlType = 'mdc-text-field';
            _this.label = undefined;
            _this.placeholder = undefined;
            _this.tabIndex = 0;
            _this.prefix = undefined;
            _this.suffix = undefined;
            _this._id = '';
            _this._type = 'text';
            _this._outlined = false;
            _this._disabled = false;
            _this._required = false;
            _this._readonly = false;
            _this._fullwidth = false;
            _this._helperPersistent = false;
            _this._useNativeValidation = true;
            _this._charCounter = false;
            _this._endAligned = false;
            _this._ltrText = false;
            _this.change = new core.EventEmitter();
            _this.input = new core.EventEmitter();
            _this.blur = new core.EventEmitter();
            _this._onFocus = new core.EventEmitter();
            /** View to model callback called when value changes */
            _this._onChange = function () { };
            /** View to model callback called when text field has been touched */
            _this._onTouched = function () { };
            if (_this.ngControl) {
                // Note: we provide the value accessor through here, instead of
                // the `providers` to avoid running into a circular import.
                _this.ngControl.valueAccessor = _this;
            }
            if (_this._parentFormField) {
                _parentFormField.elementRef.nativeElement.classList.add('ngx-form-field-text-field');
            }
            // Force setter to be called in case id was not specified.
            _this.id = _this.id;
            _this._setDefaultGlobalOptions();
            return _this;
        }
        Object.defineProperty(MdcTextField.prototype, "id", {
            get: function () {
                return this._id;
            },
            set: function (value) {
                this._id = value || this._uid;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "type", {
            /** Input type of the element. */
            get: function () {
                return this._type;
            },
            set: function (value) {
                this._type = value || 'text';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "outlined", {
            get: function () {
                return this._outlined;
            },
            set: function (value) {
                this._outlined = coercion.coerceBooleanProperty(value);
                if (this._initialized) {
                    this._layout();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "disabled", {
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                this.setDisabledState(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "required", {
            get: function () {
                return this._required;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._required) {
                    this._required = newValue;
                    if (this._initialized) {
                        if (!this.valid) {
                            this._foundation.setValid(true);
                            this._changeDetectorRef.markForCheck();
                        }
                        if (this.ngControl) {
                            this._required ? this._getInputElement().setAttribute('required', '') :
                                this._getInputElement().removeAttribute('required');
                        }
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "readonly", {
            get: function () {
                return this._readonly;
            },
            set: function (value) {
                this._readonly = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "fullwidth", {
            get: function () {
                return this._fullwidth;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._fullwidth) {
                    this._fullwidth = newValue;
                    this.placeholder = this.fullwidth ? this.label : '';
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "helperPersistent", {
            get: function () {
                return this._helperPersistent;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._helperPersistent) {
                    this._helperPersistent = newValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "valid", {
            /** Sets the Text Field valid or invalid. */
            get: function () {
                return this._valid;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._valid) {
                    this._valid = value;
                    this._foundation.setValid(newValue);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "useNativeValidation", {
            /** Enables or disables the use of native validation. Use this for custom validation. */
            get: function () {
                return this._useNativeValidation;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._useNativeValidation) {
                    this._useNativeValidation = newValue;
                    this._foundation.setUseNativeValidation(this._useNativeValidation);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "charCounter", {
            get: function () {
                return this._charCounter;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._charCounter) {
                    this._charCounter = newValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "endAligned", {
            get: function () {
                return this._endAligned;
            },
            set: function (value) {
                this._endAligned = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "ltrText", {
            get: function () {
                return this._ltrText;
            },
            set: function (value) {
                this._ltrText = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "value", {
            get: function () {
                return this._value;
            },
            set: function (newValue) {
                if (!this._initialized) {
                    this.ngControl ? this._initializeValue() : this._initializeValue(newValue);
                }
                else {
                    this.setValue(newValue, true);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "textarea", {
            get: function () {
                return this._getHostElement().nodeName.toLowerCase() === 'mdc-textarea';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "leadingIcon", {
            get: function () {
                var _a;
                return (_a = this._icons) === null || _a === void 0 ? void 0 : _a.find(function (icon) { return icon.leading; });
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTextField.prototype, "trailingIcon", {
            get: function () {
                var _a;
                return (_a = this._icons) === null || _a === void 0 ? void 0 : _a.find(function (icon) { return icon.trailing; });
            },
            enumerable: true,
            configurable: true
        });
        MdcTextField.prototype.getDefaultFoundation = function () {
            var adapter = __assign(__assign(__assign(__assign(__assign({}, this._getRootAdapterMethods()), this._getInputAdapterMethods()), this._getLabelAdapterMethods()), this._getLineRippleAdapterMethods()), this._getOutlineAdapterMethods());
            return new textfield.MDCTextFieldFoundation(adapter, this._getFoundationMap());
        };
        MdcTextField.prototype._getRootAdapterMethods = function () {
            var _this = this;
            return {
                addClass: function (className) { return _this._getHostElement().classList.add(className); },
                removeClass: function (className) { return _this._getHostElement().classList.remove(className); },
                hasClass: function (className) { return _this._getHostElement().classList.contains(className); },
                registerTextFieldInteractionHandler: function (evtType, handler) {
                    return _this._getHostElement().addEventListener(evtType, handler);
                },
                deregisterTextFieldInteractionHandler: function (evtType, handler) {
                    return _this._getHostElement().removeEventListener(evtType, handler);
                },
            };
        };
        MdcTextField.prototype._getInputAdapterMethods = function () {
            var _this = this;
            return {
                getNativeInput: function () {
                    var _a;
                    return {
                        maxLength: (_a = _this.maxlength) !== null && _a !== void 0 ? _a : 0,
                        type: _this.type,
                        value: _this._platform.isBrowser ? _this._input.nativeElement.value : _this._value,
                        disabled: _this._disabled,
                        validity: {
                            valid: _this._isValid(),
                            badInput: _this._platform.isBrowser ? _this._input.nativeElement.validity.badInput : false
                        }
                    };
                },
                isFocused: function () { return _this._platform.isBrowser ? document.activeElement === _this._getInputElement() : false; },
                registerInputInteractionHandler: function () { },
                deregisterInputInteractionHandler: function () { }
            };
        };
        MdcTextField.prototype._getLabelAdapterMethods = function () {
            var _this = this;
            return {
                shakeLabel: function (shouldShake) { var _a; return (_a = _this._getFloatingLabel()) === null || _a === void 0 ? void 0 : _a.shake(shouldShake); },
                floatLabel: function (shouldFloat) { var _a; return (_a = _this._getFloatingLabel()) === null || _a === void 0 ? void 0 : _a.float(shouldFloat); },
                hasLabel: function () { return _this._hasFloatingLabel(); },
                getLabelWidth: function () { var _a, _b; return (_b = (_a = _this._getFloatingLabel()) === null || _a === void 0 ? void 0 : _a.getWidth()) !== null && _b !== void 0 ? _b : 0; }
            };
        };
        MdcTextField.prototype._getLineRippleAdapterMethods = function () {
            var _this = this;
            return {
                activateLineRipple: function () { var _a; return (_a = _this._lineRipple) === null || _a === void 0 ? void 0 : _a.activate(); },
                deactivateLineRipple: function () { var _a; return (_a = _this._lineRipple) === null || _a === void 0 ? void 0 : _a.deactivate(); },
                setLineRippleTransformOrigin: function (normalizedX) { var _a; return (_a = _this._lineRipple) === null || _a === void 0 ? void 0 : _a.setRippleCenter(normalizedX); }
            };
        };
        MdcTextField.prototype._getOutlineAdapterMethods = function () {
            var _this = this;
            return {
                hasOutline: function () { return !!_this._notchedOutline; },
                notchOutline: function (labelWidth) { return _this._notchedOutline.notch(labelWidth); },
                closeOutline: function () { return _this._notchedOutline.closeNotch(); }
            };
        };
        /** Returns a map of all subcomponents to subfoundations.*/
        MdcTextField.prototype._getFoundationMap = function () {
            var _a, _b, _c, _d;
            return {
                helperText: (_a = this._foundationHelper) === null || _a === void 0 ? void 0 : _a.foundation,
                characterCounter: (_b = this._foundationCharCounter) === null || _b === void 0 ? void 0 : _b.foundation,
                leadingIcon: (_c = this.leadingIcon) === null || _c === void 0 ? void 0 : _c.foundation,
                trailingIcon: (_d = this.trailingIcon) === null || _d === void 0 ? void 0 : _d.foundation
            };
        };
        MdcTextField.prototype._asyncBuildFoundation = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this._foundation = this.getDefaultFoundation();
                    return [2 /*return*/];
                });
            });
        };
        MdcTextField.prototype.ngOnChanges = function (changes) {
            if (changes['helper'] || changes['helperPersistent'] || changes['validationMessage']) {
                this._syncHelper();
            }
            if (changes['charCounter']) {
                this._syncCharacterCounter();
            }
        };
        MdcTextField.prototype.ngAfterViewInit = function () {
            this.init();
        };
        MdcTextField.prototype.ngOnDestroy = function () {
            this.destroy();
            this._foundation.destroy();
        };
        MdcTextField.prototype.ngDoCheck = function () {
            if (this.ngControl) {
                // We need to re-evaluate this on every change detection cycle, because there are some
                // error triggers that we can't subscribe to (e.g. parent form submissions). This means
                // that whatever logic is in here has to be super lean or we risk destroying the performance.
                this.updateErrorState();
            }
        };
        MdcTextField.prototype.init = function () {
            var _this = this;
            this._initialized = true;
            this._asyncBuildFoundation()
                .then(function () {
                var _a, _b, _c, _d, _e;
                _this._foundation.init();
                if (!_this.fullwidth && !_this.outlined && !_this.textarea) {
                    _this._ripple = new ripple.MdcRipple(_this.elementRef);
                    _this._ripple.init();
                }
                else {
                    (_a = _this._ripple) === null || _a === void 0 ? void 0 : _a.destroy();
                }
                _this._checkCustomValidity();
                (_c = (_b = _this.leadingIcon) === null || _b === void 0 ? void 0 : _b.foundation) === null || _c === void 0 ? void 0 : _c.init();
                (_e = (_d = _this.trailingIcon) === null || _d === void 0 ? void 0 : _d.foundation) === null || _e === void 0 ? void 0 : _e.init();
                _this.disabled = _this._input.nativeElement.disabled;
            });
        };
        MdcTextField.prototype.onInputInteraction = function (evt) {
            if (evt instanceof MouseEvent) {
                var isSyntheticEvent = this._lastTouchStartEvent &&
                    Date.now() < this._lastTouchStartEvent + MOUSE_EVENT_IGNORE_TIME;
                if (isSyntheticEvent) {
                    return;
                }
            }
            else {
                this._lastTouchStartEvent = Date.now();
            }
            this._foundation.setTransformOrigin(evt);
        };
        MdcTextField.prototype.onInput = function (evt) {
            var value = evt.target.value;
            this.setValue(value, true);
            this._foundation.handleInput();
            this.input.emit(value);
            evt.stopPropagation();
        };
        MdcTextField.prototype.onFocus = function () {
            if (this._initialized) {
                this._foundation.activateFocus();
                this._onFocus.emit(true);
            }
        };
        MdcTextField.prototype.onChange = function (evt) {
            var value = evt.target.value;
            this.setValue(value, true);
            this.change.emit(value);
            evt.stopPropagation();
        };
        MdcTextField.prototype.onBlur = function () {
            this._onTouched();
            this._foundation.deactivateFocus();
            this.blur.emit(this.value);
            this._onFocus.emit(false);
        };
        MdcTextField.prototype.writeValue = function (value) {
            this.setValue(value);
        };
        MdcTextField.prototype.registerOnChange = function (fn) {
            this._onChange = fn;
        };
        MdcTextField.prototype.registerOnTouched = function (fn) {
            this._onTouched = fn;
        };
        MdcTextField.prototype._initializeValue = function (value) {
            var _this = this;
            // Defer setting the value in order to avoid the "Expression
            // has changed after it was checked" errors from Angular.
            Promise.resolve().then(function () {
                _this.setValue(_this.ngControl ? _this.ngControl.value : value);
            });
        };
        MdcTextField.prototype.setValue = function (value, isUserInput) {
            var newValue = this.type === 'number' ? coercion.coerceNumberProperty(value, null) : value;
            if (this._value === newValue) {
                // Reset validity for numeric form inputs
                if (newValue === null) {
                    this.valid = true;
                }
                return;
            }
            this._value = newValue !== undefined ? newValue : null;
            if (this._getInputElement().value !== this._value) {
                this._getInputElement().value = this._value;
            }
            this._foundation.setValue(this._value || '');
            if (isUserInput) {
                this._onChange(this._value);
            }
            this._changeDetectorRef.markForCheck();
        };
        MdcTextField.prototype.isBadInput = function () {
            var validity = this._getInputElement().validity;
            return validity && validity.badInput;
        };
        MdcTextField.prototype.focus = function () {
            var _a;
            (_a = this._getInputElement()) === null || _a === void 0 ? void 0 : _a.focus();
        };
        /** Initializes Text Field's internal state based on the environment state */
        MdcTextField.prototype._layout = function () {
            var _this = this;
            this.destroy();
            this.init();
            this._changeDetectorRef.markForCheck();
            setTimeout(function () {
                var _a;
                if (_this._outlined) {
                    _this._foundation.notchOutline(_this._foundation.shouldFloat);
                }
                (_a = _this._getFloatingLabel()) === null || _a === void 0 ? void 0 : _a.float(_this._foundation.shouldFloat);
            });
        };
        /** Implemented as part of ControlValueAccessor. */
        MdcTextField.prototype.setDisabledState = function (isDisabled) {
            var newValue = coercion.coerceBooleanProperty(isDisabled);
            if (newValue !== this._disabled) {
                this._disabled = newValue;
                if (this._initialized) {
                    this._foundation.setDisabled(newValue);
                }
                this._changeDetectorRef.markForCheck();
            }
        };
        /** Set the default options here. */
        MdcTextField.prototype._setDefaultGlobalOptions = function () {
            if (this._defaults && this._defaults.outlined) {
                this._outlined = this._defaults.outlined;
            }
        };
        MdcTextField.prototype._checkCustomValidity = function () {
            var _this = this;
            Promise.resolve().then(function () {
                if (_this._valid !== undefined) {
                    _this._foundation.setValid(_this._valid);
                }
            });
        };
        /** Override MdcTextFieldBase destroy method */
        MdcTextField.prototype.destroy = function () {
            var _a, _b;
            this._initialized = false;
            (_a = this._lineRipple) === null || _a === void 0 ? void 0 : _a.destroy();
            (_b = this._ripple) === null || _b === void 0 ? void 0 : _b.destroy();
        };
        MdcTextField.prototype._isValid = function () {
            var _a, _b, _c, _d;
            var isValid = this._valid ? this._valid : this._platform.isBrowser ?
                this._input.nativeElement.validity.valid : true;
            var showValidationMessage = !!this.validationMessage && !isValid || this.errorState;
            if (this._shouldRenderHelperText()) {
                (_a = this._foundationHelper) === null || _a === void 0 ? void 0 : _a.setContent(showValidationMessage ? (_b = this.validationMessage) !== null && _b !== void 0 ? _b : '' : (_c = this.helper) !== null && _c !== void 0 ? _c : '');
                if (showValidationMessage) {
                    (_d = this._foundationHelper) === null || _d === void 0 ? void 0 : _d.setValidation(showValidationMessage);
                }
            }
            if (this.ngControl) {
                return !this.errorState;
            }
            return isValid;
        };
        MdcTextField.prototype._hasFloatingLabel = function () {
            return this.label && (this._floatingLabel || this._notchedOutline) ? true : false;
        };
        MdcTextField.prototype._getFloatingLabel = function () {
            var _a;
            return this._floatingLabel || ((_a = this._notchedOutline) === null || _a === void 0 ? void 0 : _a.floatingLabel);
        };
        MdcTextField.prototype._syncCharacterCounter = function () {
            var _a;
            if (!this.charCounter) {
                (_a = this._foundationCharCounter) === null || _a === void 0 ? void 0 : _a.destroy();
                return;
            }
            if (this._shouldRenderHelperText()) {
                this._initHelperFoundation();
            }
            if (!this._foundationCharCounter) {
                this._foundationCharCounter = new MdcTextFieldCharacterCounterFoundation(this._elementRef, this.textarea ? this.elementRef.nativeElement : this._foundationHelper._helperLineElement, this._document);
                this._foundationCharCounter.init();
            }
        };
        MdcTextField.prototype._syncHelper = function () {
            if (this._shouldRenderHelperText()) {
                this._initHelperFoundation();
            }
            this._foundationHelper.setPersistent(this._helperPersistent);
        };
        MdcTextField.prototype._initHelperFoundation = function () {
            if (!this._foundationHelper) {
                this._foundationHelper = new MdcTextFieldHelperTextFoundation(this._elementRef, this._document);
                this._foundationHelper.init();
            }
        };
        MdcTextField.prototype._charCounterVisible = function () {
            return this.charCounter && this.maxlength !== -1;
        };
        MdcTextField.prototype._shouldRenderHelperText = function () {
            return !!this.helper || !!this.validationMessage || this._charCounterVisible();
        };
        MdcTextField.prototype._getInputElement = function () {
            return this._input.nativeElement;
        };
        /** Retrieves the DOM element of the component host. */
        MdcTextField.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcTextField.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-text-field',
                        exportAs: 'mdcTextField',
                        host: {
                            'class': 'mdc-text-field',
                            '[class.mdc-text-field--filled]': '!outlined',
                            '[class.mdc-text-field--disabled]': 'disabled',
                            '[class.mdc-text-field--outlined]': 'outlined',
                            '[class.mdc-text-field--fullwidth]': 'fullwidth',
                            '[class.mdc-text-field--end-aligned]': 'endAligned',
                            '[class.mdc-text-field--ltr-text]': 'ltrText',
                            '[class.mdc-text-field--with-leading-icon]': 'leadingIcon',
                            '[class.mdc-text-field--with-trailing-icon]': 'trailingIcon',
                            '[class.mdc-text-field--no-label]': '!label || label && fullwidth',
                            '[class.mdc-text-field--invalid]': 'errorState',
                        },
                        template: "<div class=\"mdc-text-field__ripple\"></div>\r\n<ng-content *ngIf=\"leadingIcon || trailingIcon\"></ng-content>\r\n<span class=\"mdc-text-field__affix mdc-text-field__affix--prefix\" *ngIf=\"prefix\">{{prefix}}</span>\r\n<input #inputElement class=\"mdc-text-field__input\"\r\n  [id]=\"id\"\r\n  [type]=\"type\"\r\n  [tabindex]=\"tabIndex\"\r\n  [attr.name]=\"name\"\r\n  [attr.inputmode]=\"inputmode\"\r\n  [attr.aria-invalid]=\"errorState\"\r\n  [attr.autocomplete]=\"autocomplete\"\r\n  [attr.pattern]=\"pattern\"\r\n  [attr.placeholder]=\"placeholder\"\r\n  [attr.maxlength]=\"maxlength\"\r\n  [attr.minlength]=\"minlength\"\r\n  [attr.max]=\"max\"\r\n  [attr.min]=\"min\"\r\n  [attr.size]=\"size\"\r\n  [attr.step]=\"step\"\r\n  [disabled]=\"disabled\"\r\n  [readonly]=\"readonly\"\r\n  [required]=\"required\"\r\n  (mousedown)=\"onInputInteraction($event)\"\r\n  (touchstart)=\"onInputInteraction($event)\"\r\n  (focus)=\"onFocus()\"\r\n  (input)=\"onInput($event)\"\r\n  (change)=\"onChange($event)\"\r\n  (blur)=\"onBlur()\" />\r\n<span class=\"mdc-text-field__affix mdc-text-field__affix--suffix\" *ngIf=\"suffix\">{{suffix}}</span>\r\n<ng-content></ng-content>\r\n<label mdcFloatingLabel [for]=\"id\" *ngIf=\"!placeholder && !outlined\">{{label}}</label>\r\n<mdc-line-ripple *ngIf=\"!outlined\"></mdc-line-ripple>\r\n<mdc-notched-outline *ngIf=\"outlined\" [label]=\"label\" [for]=\"id\"></mdc-notched-outline>",
                        providers: [
                            ripple.MdcRipple,
                            { provide: formField.MdcFormFieldControl, useExisting: MdcTextField }
                        ],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcTextField.ctorParameters = function () { return [
            { type: platform.Platform },
            { type: core.ChangeDetectorRef },
            { type: core.ElementRef },
            { type: formField.ErrorStateMatcher },
            { type: undefined, decorators: [{ type: core.Inject, args: [common.DOCUMENT,] }] },
            { type: formField.MdcFormField, decorators: [{ type: core.Optional }] },
            { type: ripple.MdcRipple, decorators: [{ type: core.Optional }] },
            { type: forms.NgControl, decorators: [{ type: core.Self }, { type: core.Optional }] },
            { type: forms.NgForm, decorators: [{ type: core.Optional }] },
            { type: forms.FormGroupDirective, decorators: [{ type: core.Optional }] },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MDC_TEXT_FIELD_DEFAULT_OPTIONS,] }] }
        ]; };
        MdcTextField.propDecorators = {
            name: [{ type: core.Input }],
            label: [{ type: core.Input }],
            maxlength: [{ type: core.Input }],
            minlength: [{ type: core.Input }],
            pattern: [{ type: core.Input }],
            autocomplete: [{ type: core.Input }],
            max: [{ type: core.Input }],
            min: [{ type: core.Input }],
            size: [{ type: core.Input }],
            step: [{ type: core.Input }],
            placeholder: [{ type: core.Input }],
            tabIndex: [{ type: core.Input }],
            prefix: [{ type: core.Input }],
            suffix: [{ type: core.Input }],
            inputmode: [{ type: core.Input }],
            helper: [{ type: core.Input }],
            validationMessage: [{ type: core.Input }],
            id: [{ type: core.Input }],
            type: [{ type: core.Input }],
            outlined: [{ type: core.Input }],
            disabled: [{ type: core.Input }],
            required: [{ type: core.Input }],
            readonly: [{ type: core.Input }],
            fullwidth: [{ type: core.Input }],
            helperPersistent: [{ type: core.Input }],
            valid: [{ type: core.Input }],
            useNativeValidation: [{ type: core.Input }],
            charCounter: [{ type: core.Input }],
            endAligned: [{ type: core.Input }],
            ltrText: [{ type: core.Input }],
            value: [{ type: core.Input }],
            errorStateMatcher: [{ type: core.Input }],
            change: [{ type: core.Output }],
            input: [{ type: core.Output }],
            blur: [{ type: core.Output }],
            _onFocus: [{ type: core.Output, args: ['focus',] }],
            _input: [{ type: core.ViewChild, args: ['inputElement', { static: true },] }],
            _lineRipple: [{ type: core.ViewChild, args: [lineRipple.MdcLineRipple, { static: false },] }],
            _notchedOutline: [{ type: core.ViewChild, args: [notchedOutline.MdcNotchedOutline, { static: false },] }],
            _floatingLabel: [{ type: core.ViewChild, args: [floatingLabel.MdcFloatingLabel, { static: false },] }],
            _icons: [{ type: core.ContentChildren, args: [MdcTextFieldIcon, { descendants: true },] }]
        };
        return MdcTextField;
    }(_MdcTextFieldMixinBase));

    var MdcTextarea = /** @class */ (function (_super) {
        __extends(MdcTextarea, _super);
        function MdcTextarea() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            /* Required outlined modifier for textarea */
            _this.outlined = true;
            return _this;
        }
        MdcTextarea.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-textarea',
                        exportAs: 'mdcTextarea',
                        host: {
                            'class': 'mdc-text-field',
                            '[class.mdc-text-field--textarea]': 'true',
                            '[class.mdc-text-field--no-label]': '!label',
                            '[class.mdc-text-field--fullwidth]': 'fullwidth',
                            '[class.mdc-text-field--invalid]': 'errorState',
                        },
                        template: "<div class=\"mdc-text-field__ripple\"></div>\r\n<textarea #inputElement class=\"mdc-text-field__input\"\r\n  [id]=\"id\"\r\n  [rows]=\"rows\"\r\n  [cols]=\"cols\"\r\n  [tabindex]=\"tabIndex\"\r\n  [attr.name]=\"name\"\r\n  [attr.aria-invalid]=\"errorState\"\r\n  [attr.maxlength]=\"maxlength\"\r\n  [attr.minlength]=\"minlength\"\r\n  [disabled]=\"disabled\"\r\n  [required]=\"required\"\r\n  [readonly]=\"readonly\"\r\n  (mousedown)=\"onInputInteraction($event)\"\r\n  (touchstart)=\"onInputInteraction($event)\"\r\n  (focus)=\"onFocus()\"\r\n  (input)=\"onInput($event)\"\r\n  (change)=\"onChange($event)\"\r\n  (blur)=\"onBlur()\"></textarea>\r\n<mdc-notched-outline [label]=\"label\" [for]=\"id\"></mdc-notched-outline>",
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None
                    }] }
        ];
        MdcTextarea.propDecorators = {
            rows: [{ type: core.Input }],
            cols: [{ type: core.Input }],
            outlined: [{ type: core.Input }]
        };
        return MdcTextarea;
    }(MdcTextField));

    var TEXTFIELD_DECLARATIONS = [
        MdcTextarea,
        MdcTextField,
        MdcTextFieldIcon
    ];
    var MdcTextFieldModule = /** @class */ (function () {
        function MdcTextFieldModule() {
        }
        MdcTextFieldModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [
                            common.CommonModule,
                            formField.MdcFormFieldModule,
                            lineRipple.MdcLineRippleModule,
                            floatingLabel.MdcFloatingLabelModule,
                            notchedOutline.MdcNotchedOutlineModule
                        ],
                        exports: [
                            formField.MdcFormFieldModule,
                            TEXTFIELD_DECLARATIONS
                        ],
                        declarations: TEXTFIELD_DECLARATIONS
                    },] }
        ];
        return MdcTextFieldModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MDC_TEXT_FIELD_DEFAULT_OPTIONS = MDC_TEXT_FIELD_DEFAULT_OPTIONS;
    exports.MdcTextField = MdcTextField;
    exports.MdcTextFieldCharacterCounterFoundation = MdcTextFieldCharacterCounterFoundation;
    exports.MdcTextFieldHelperTextFoundation = MdcTextFieldHelperTextFoundation;
    exports.MdcTextFieldIcon = MdcTextFieldIcon;
    exports.MdcTextFieldModule = MdcTextFieldModule;
    exports.MdcTextarea = MdcTextarea;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-textfield.umd.js.map
